import script from "./BuToast.vue?vue&type=script&setup=true&lang=js"
export * from "./BuToast.vue?vue&type=script&setup=true&lang=js"

import "./BuToast.vue?vue&type=style&index=0&id=5d5de186&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d5de186"]])

export default __exports__